/**
 * 统一的 Chart.js 配置模块
 * 避免在每个组件中重复注册 Chart.js 组件
 */
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  ArcElement,
} from 'chart.js';

// 注册所有 Chart.js 组件
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  ArcElement
);

// 默认图表主题色
export const CHART_COLORS = {
  primary: 'rgb(37, 99, 235)',
  primaryAlpha: 'rgba(37, 99, 235, 0.1)',
  success: 'rgb(22, 163, 74)',
  successAlpha: 'rgba(22, 163, 74, 0.1)',
  warning: 'rgb(255, 193, 7)',
  warningAlpha: 'rgba(255, 193, 7, 0.8)',
  danger: 'rgb(220, 38, 38)',
  dangerAlpha: 'rgba(220, 38, 38, 0.1)',
  purple: 'rgb(124, 58, 237)',
  purpleAlpha: 'rgba(124, 58, 237, 0.1)',
  pink: 'rgb(235, 47, 150)',
  pinkAlpha: 'rgba(235, 47, 150, 0.5)',
};

// 默认图表配置选项
export const defaultChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
    },
  },
  scales: {
    y: {
      beginAtZero: true,
      grid: {
        color: 'rgba(0,0,0,0.05)',
      },
    },
    x: {
      grid: {
        display: false,
      },
    },
  },
};

// 带标题的图表选项
export const chartOptionsWithTitle = (title, subtitle) => ({
  ...defaultChartOptions,
  plugins: {
    ...defaultChartOptions.plugins,
    legend: {
      display: false,
    },
    title: {
      display: true,
      text: title,
      font: {
        size: 16,
        weight: 600,
      },
      color: '#111827',
      padding: {
        bottom: 16,
      },
    },
    subtitle: subtitle
      ? {
          display: true,
          text: subtitle,
          font: {
            size: 12,
            color: '#5b6472',
          },
          padding: {
            bottom: 12,
          },
        }
      : undefined,
  },
});

// 折线图特定配置
export const lineChartOptions = (title) => ({
  ...defaultChartOptions,
  elements: {
    line: {
      tension: 0.4,
    },
  },
  plugins: {
    ...defaultChartOptions.plugins,
    title: {
      display: !!title,
      text: title,
      font: {
        size: 16,
        weight: 600,
      },
      color: '#111827',
      padding: {
        bottom: 16,
      },
    },
  },
});

// 柱状图特定配置
export const barChartOptions = (title) => ({
  ...defaultChartOptions,
  plugins: {
    ...defaultChartOptions.plugins,
    title: {
      display: !!title,
      text: title,
      font: {
        size: 16,
        weight: 600,
      },
      color: '#111827',
      padding: {
        bottom: 16,
      },
    },
  },
});

// 创建渐变填充配置
export const createGradientConfig = (chart) => {
  const ctx = chart.ctx;
  const gradient = ctx.createLinearGradient(0, 0, 0, chart.height);
  gradient.addColorStop(0, CHART_COLORS.primaryAlpha);
  gradient.addColorStop(1, 'rgba(255, 255, 255, 0)');
  return gradient;
};

export default ChartJS;